import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { PopupGuard } from './guards/index';

import {
  MapComponent,
  PopupComponent,
  HomeComponent
} from './components/index';

export const appRoutes: Routes  = [
  { path: '', component: HomeComponent,
    children: [
      { path: 'open/:popup', component: PopupComponent, canActivate: [PopupGuard],
        children: [
          { path: ':inner', component: PopupComponent, 
            children: [
              { path: ':subInner', component: PopupComponent }
            ]
          }
        ]
      },
    ]
  },
  { path: 'map', component: MapComponent,
    children: [
      { path: ':popup', component: PopupComponent, canActivate: [PopupGuard],
        children: [
          { path: ':inner', component: PopupComponent, 
            children: [
              { path: ':subInner', component: PopupComponent }
            ]
          }
        ]
      },
    ]
  },
  { path: '**', pathMatch: 'full', redirectTo: '/map'}
];

export const appRoutingProviders: any[] = [

];

export const routing: ModuleWithProviders = RouterModule.forRoot(appRoutes);



// WEBPACK FOOTER //
// ./src/app/app.routes.ts